import React from 'react';
import '../styles/notification-modal.scss';

export interface NotificationPermissionModalProps {
  isOpen: boolean;
  onAccept: () => Promise<void> | void;
  onDismiss?: () => void;
  isSubmitting?: boolean;
  image?: string;
  tag?: string;
  tagIcon?: string;
  title?: string;
  message?: string;
  actionText?: string;
  submittingText?: string;
  className?: string;
}

export const NotificationPermissionModal: React.FC<NotificationPermissionModalProps> = ({
  isOpen,
  onAccept,
  onDismiss,
  isSubmitting = false,
  image = '/assets/img/notifications/browser_permission_guide.png',
  tag = 'Stay Connected',
  tagIcon = 'fa-solid fa-bell',
  title = "Don't Miss Out on Important Updates!",
  message = 'Enable desktop notifications to stay on top of your work! Get instant alerts for new task assignments, urgent field dispatches, and real-time operational updates right on your screen. When your browser asks for permission, please click "Allow" to stay connected.',
  actionText = "Ok, I'm understand",
  submittingText = 'Connecting...',
  className = '',
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={`notif-modal-overlay ${className}`.trim()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="notif-modal-title"
    >
      <div className="notif-modal-card">
        {/* Optional Close Button */}
        {onDismiss && (
          <button
            type="button"
            className="notif-modal-close-btn"
            onClick={onDismiss}
            aria-label="Close dialog"
            disabled={isSubmitting}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        )}

        {/* Single Hero Image */}
        <div className="notif-modal-hero">
          <img src={image} alt={title} loading="eager" />
        </div>

        {/* Modal Content */}
        <div className="notif-modal-content">
          <div className="notif-modal-tag-wrap">
            <span className="notif-modal-tag">
              {tagIcon && <i className={tagIcon}></i>}
              {tag}
            </span>
          </div>

          <h3 id="notif-modal-title" className="notif-modal-title">
            {title}
          </h3>

          <p className="notif-modal-desc">{message}</p>

          {/* Single Action Button */}
          <div className="notif-modal-actions">
            <button
              type="button"
              className="notif-modal-btn-primary"
              onClick={onAccept}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <i className="fa-solid fa-spinner fa-spin"></i>
                  <span>{submittingText}</span>
                </>
              ) : (
                <>
                  <i className="fa-solid fa-bell notif-bell-shake"></i>
                  <span>{actionText}</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationPermissionModal;
